export enum Gender {
  MALE = 10,
  FEMALE = 20,
}

export type ActiveDocument = {
  id: string;
  name: string;
  description: string;
  category: string;
  required: boolean;
  type: string;
  employer_types: string[];
  sort_order: number;
  created_at: string;
  updated_at: string;
};
